import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import APICom from "../../../../utils/helpers/APICom";
import GridControl from '../../../../components/Controls/gridControl.js'
import MultiSelectDropdown from '../../../Controls/multiselectdropdown';

const DriverSearch = (props) => {
    const [DriverSearchGridResponse, setDriverSearchGridResponse] = useState("");
    const xCancelSourceForGrid = useRef(null);
    const { loginData } = useSelector((store) => store.login);
    const { FamilyData, DispatchGridColorsData} = useSelector((store) => store.combinedata);
    const [ShowGridLoader, setShowGridLoader] = useState(false);
    const handleClose = () =>  props.setDriverSearchComponentLoad(false);
    const handleShow = () => props.setDriverSearchComponentLoad(true);
    const [showDriverSearchAlert, setDriverSearchAlert] = useState(false);
    const [apiRowData, setApiRowData] = useState(DispatchGridColorsData[0]);
    const [apiColData, setApiColData] = useState(DispatchGridColorsData[1]);
    const [driverSearchAlertObj, setDriverSearchAlertObj] = useState({ alertTitle: '', alertMsg: '' });
    const [FamilyGroupsSingleSelect, SetFamilyGroupsMultiSelect] = useState({ options: [], selectedValues: [], placeholder: "Family Filter", displayValue: "name", emptyRecordMsg: "N/A", id: "DriverSearchGridFamilySelect", className: "DriverSearchGridFamilySelect", singleSelect: true, showCheckbox: false, TriggerSelectEventOnDataPopulate: false, styles: { width: "150px", marginLeft: "10px" } });
    const familyDropdown = useRef(null);
    const vehicleSelection = useRef(null);
    const mystyle = {
        height: "300px"
    };

    const handleDriverSearchAlertClose = () => {
        setDriverSearchAlert(false);
        UnMountDriverSearchComponent();
    }

    const UnMountDriverSearchComponent = () => {
        if (props.driversearchComponentLoaded) {
            props.setDriverSearchComponentLoad(false);
        }
    }


    const handleVehicleOnchange = (event) => {        
        vehicleSelection.current = event.target.value;
    }

    const handleFamilyOnchange = (val) => {
        familyDropdown.current = val[0];
    }

    const handleDriverSearch = () => {
      PrepareDriverSearchRequest();
    }

    const [ToolboxValues, SetToolboxValues] = useState({
        ddlFamily:"",txtVehicleNumber:""
      });

    const [DriverSearchGridControlOptions, SetDriverSearchGridControlOptions] = useState({
        height: '300',
        heightoffset: 600,
        calculateHeight: true,
        pagination: true,
        paginationMode: "local",
        paginationSize: [100],
        selectable: 1,
        reactiveData: true, //enable data reactivity
        layout: "fitDataStretch",
        placeholder: "No Data Available",
        selectableRangeMode: "click",
        GridName: "driverSearchGrid",
        clipboard: false,
        paginationCounter: "rows",
        movableColumns: true,
        vDefaultGridName: "DriverSearchGrid_grdControl",
        index:"id",
        bSysUser: 1,
        autoColumns: true,
        sortCondition: true,
        intervalEnable: false,
        persistence:false,
        bWebApplySettingToAll: true,
        ID_Column: "iDriverID",
        GridReturnOnlyIDColumnInRowData: false,
        containerClass: "col position-relative",
        Containerstyle: {},
        footerElement: '',
        footerElementHandles: function(){},
        tableDoubleClickFunc: function(table, row) {
        },
        rowSelectionChangeHandle: function(data){ 
        },
        AlwaysHiddenColumns: ["Other"]
    });

    const PrepareDriverSearchRequest = async () => {
        setShowGridLoader(true);
        xCancelSourceForGrid.current = APICom.GenerateSource();
        const data = {
            "searchtext": vehicleSelection.current,
            "FamilyID": familyDropdown.current,
            "user_id": loginData.iUserID
        }
        
        let response = await APICom.fetchData("main", "GridData/GetDriverSearchGridData", "post", {}, data, xCancelSourceForGrid.current);
        if (response.error === "") {
            setDriverSearchGridResponse({"data":response.data});
        }
        
        setShowGridLoader(false);
    }

    useEffect( () => {
        if (props.GridRowData === null || props.GridRowData.length <= 0) {
            setDriverSearchAlertObj({ ...driverSearchAlertObj, alertTitle: 'No trip selected', alertMsg: 'No request selected to perform driver search.' });
            setDriverSearchAlert(true);
        }
        else {
            
            let initialFamilyGroupSelected = [];
            let optsFamily = [];
            for (var i = 0; i < FamilyData.length; i++) {
                if (i === 0) { initialFamilyGroupSelected.push(FamilyData[i]["iATSPGroupID"].toString()); }
                optsFamily.push({ "name": FamilyData[i]["vATSPGroupName"], "id": FamilyData[i]["iATSPGroupID"] })
            }
            SetFamilyGroupsMultiSelect({ ...FamilyGroupsSingleSelect, ...{ options: optsFamily } });
            familyDropdown.current = FamilyData[0]["iATSPGroupID"];
            vehicleSelection.current = (props.GridRowData[0].VREQ && props.GridRowData[0].VREQ !== "None") ? props.GridRowData[0].VREQ : '';
            props.setDriverSearchComponentLoad(true);
            
            PrepareDriverSearchRequest();
        }
    }, []);
    return (
        <>

            {props.driversearchComponentLoaded ? <Modal show={props.driversearchComponentLoaded} onHide={handleClose} backdrop={"static"} keyboard={true} size="xl" centered>
                <Modal.Header closeButton className="activate_dialog_header_bgcolor">
                    <Modal.Title className="activate_dialog_title_color">Driver Search</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Row>
                            <Form.Group className="mb-3 col-md-6">
                                <Form.Label>Affiliate Group</Form.Label>
                                <MultiSelectDropdown controlid="ddlFamily" options={FamilyGroupsSingleSelect} singleselect="true" SelectionChangeCallback={handleFamilyOnchange} />
                            </Form.Group>
                            <Form.Group className="mb-3 col-md-6">
                                <Form.Label>Vehicle #</Form.Label>
                                <Form.Control type="text" controlid="txtVehicleNumber" defaultValue={vehicleSelection.current}  className="txtVehicleNumber" onChange={handleVehicleOnchange}></Form.Control >
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <GridControl Data={DriverSearchGridResponse} rowColors={apiRowData} cellColors={apiColData} ReloadDataFunction={PrepareDriverSearchRequest} options={DriverSearchGridControlOptions} ShowLoader={ShowGridLoader}/>
                        </Row>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="dark" onClick={handleDriverSearch}>
                        Search
                    </Button>
                    <Button variant="dark" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>: ""}
            {showDriverSearchAlert ? <Modal centered show={showDriverSearchAlert} onHide={handleDriverSearchAlertClose} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>{driverSearchAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{driverSearchAlertObj.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="dark" onClick={handleDriverSearchAlertClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>:""}
        </>
    );
};


export default DriverSearch;